// extracted by mini-css-extract-plugin
module.exports = {"back":"styles-module--back--3OiN6","arrow":"styles-module--arrow--2h4iZ","text":"styles-module--text--wyDqc"};